export type StickyBehaviour =
  | 'sticky'
  | 'none'
  | 'mobile-only'
  | 'desktop-only';

export interface HeaderFooterParams {
  /** Return header data. Default value is `true`. */
  header?: boolean;

  /** Return footer data. Default value is `true`. */
  footer?: boolean;

  /** Language of header and footer. Default value is taken from Wix aspects. */
  language?: string;

  /**
   * Setup custom list of languages in language picker.
   * Default value contains around 22 languages.
   */
  languagePickerList?: string[];

  /**
   * The URL the user will be redirected to after successful login.
   * Default: `https://manage.wix.com/account/route`
   */
  postLogin?: string;

  /**
   * The URL the user will be redirected to after successful signup.
   * Default: `https://www.wix.com/new/intro/`
   */
  postSignUp?: string;

  /**
   * The URL the user will be redirected to after successful sign out.
   * Default: `https://www.wix.com/`
   */
  postSignOut?: string;

  /** Expose methods to interact with header in `window.HeaderAPI`. */
  exposeApi?: boolean;

  /**
   * Configure the stickiness of Header.
   * Default value is `'sticky'`.
   */
  stickyBehaviour?: StickyBehaviour;

  /** Show tooltip on logo. Default value is `false`. */
  showTooltipOnLogo?: boolean;

  /**
   * Selector to main content that allows showing "Skip To Main Content"
   * button before Header.
   */
  mainContentSelector?: string;

  brand?: string;
}

export interface HeaderFooterNodes {
  /** Put header into this element. */
  header?: Element;

  /** Put footer into this element. */
  footer?: Element;
}

export const HeaderAndFooterProvider = (props: HeaderFooterParams) => {
  if (window['header-footer-provider' as any]) {
    return;
  }

  const script = document.createElement('script');

  const params: HeaderFooterParams = {
    stickyBehaviour: 'mobile-only',
    ...props,
  };

  const nodes: HeaderFooterNodes = {
    header: document.getElementById('header')!,
    footer: document.getElementById('footer')!,
  };

  script.src =
    'https://static.parastorage.com/unpkg-semver/header-footer-provider/app.bundle.min.js';
  script.onload = () => {
    (window['header-footer-provider' as any] as any).initHeaderFooter(
      params,
      nodes,
    );
  };

  document.body.appendChild(script);
};
